class Search {
  constructor() {
    this.classes = {
      hidden: 'u-hidden',
      active: 'is-active',
      form: '.js-search-form',
      searchQuery: '.js-search-query',
      results: '.js-search-results',
      resultsList: '.js-search-results-list',
      loader: '.js-search-loader',
      pagination: 'js-pagination',
      pagedField: '.js-search-paged',
      filterField: '.js-search-filter',
      filter: '[data-search-filter]',
    };

    this.DOM = {
      body: document.body,
      form: document.querySelector(this.classes.form),
      searchQuery: document.querySelector(this.classes.searchQuery),
      results: document.querySelector(this.classes.results),
      resultsList: document.querySelector(this.classes.resultsList),
      loader: document.querySelector(this.classes.loader),
      pagedField: document.querySelector(this.classes.pagedField),
      filterField: document.querySelector(this.classes.filterField),
      filters: document.querySelectorAll(this.classes.filter),
    };

    this.init();
  }

  init() {
    this.addListeners();
  }

  addListeners() {
    this.DOM.form.addEventListener('submit', this.onSubmit);
    document.addEventListener('click', this.pagination);

    if (this.DOM.filters.length) {
      this.DOM.filters.forEach((filter) =>
        filter.addEventListener('click', this.filter),
      );
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.DOM.resultsList.innerHTML = '';
    this.DOM.loader.classList.remove(this.classes.hidden);
    this.DOM.results.classList.add(this.classes.hidden);

    const formData = new FormData(e.target);
    const entries = Object.fromEntries(formData);
    if (entries.s) {
      this.DOM.searchQuery.textContent = entries.s;
      this.DOM.searchQuery.parentElement.classList.remove(this.classes.hidden);
    } else {
      this.DOM.searchQuery.parentElement.classList.add(this.classes.hidden);
    }

    formData.append('action', 'search');

    /* eslint-disable no-undef */
    fetch(admin_url.ajax_url, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.data && res.data.html) {
          this.DOM.resultsList.innerHTML = res.data.html;
        }
      })
      .finally(() => {
        this.DOM.loader.classList.add(this.classes.hidden);
        this.DOM.results.classList.remove(this.classes.hidden);
        this.DOM.results.scrollTop = 0;
      });
  };

  pagination = (e) => {
    let { target } = e;
    if (!target.classList.contains(this.classes.pagination))
      target = target.parentElement;
    if (target.classList.contains(this.classes.pagination)) {
      e.preventDefault();
      const url = target.href.replace(/\/$/, '');
      const page = url.split('/');
      this.DOM.pagedField.value = parseInt(page[page.length - 1], 10);

      const formEvent = new SubmitEvent('submit');
      this.DOM.form.dispatchEvent(formEvent);
    }
  };

  filter = (e) => {
    let { target } = e;
    if (!target.dataset.searchFilter) target = target.parentElement;
    this.DOM.filters.forEach((filter) =>
      filter.classList.remove(this.classes.active),
    );
    target.classList.add(this.classes.active);
    const val = target.dataset.searchFilter ?? '';
    this.DOM.filterField.value = val;
    this.DOM.pagedField.value = 1;

    const formEvent = new SubmitEvent('submit');
    this.DOM.form.dispatchEvent(formEvent);
  };
}

export default new Search();
